// extracted by mini-css-extract-plugin
export default {"focused":"styleExtender_focused__jWYNP","pass":"styleExtender_pass__KBLzI"};